"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = void 0;
var react_1 = __importStar(require("react"));
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var slate_history_1 = require("slate-history");
var FormatBold_1 = require("@styled-icons/material/FormatBold");
var FormatItalic_1 = require("@styled-icons/material/FormatItalic");
var FormatUnderlined_1 = require("@styled-icons/material/FormatUnderlined");
var Code_1 = require("@styled-icons/material/Code");
var FormatQuote_1 = require("@styled-icons/material/FormatQuote");
var FormatListBulleted_1 = require("@styled-icons/material/FormatListBulleted");
var FormatListNumbered_1 = require("@styled-icons/material/FormatListNumbered");
var FormatStrikethrough_1 = require("@styled-icons/material/FormatStrikethrough");
var FormatAlignCenter_1 = require("@styled-icons/material/FormatAlignCenter");
var FormatAlignRight_1 = require("@styled-icons/material/FormatAlignRight");
var FormatAlignLeft_1 = require("@styled-icons/material/FormatAlignLeft");
var VideoSettings_1 = require("@styled-icons/material/VideoSettings");
var Image_1 = require("@styled-icons/material/Image");
var CodeCurly_1 = require("@styled-icons/boxicons-regular/CodeCurly");
var Highlighter_1 = require("@styled-icons/fa-solid/Highlighter");
var FormatSize_1 = require("@styled-icons/material/FormatSize");
var Height_1 = require("@styled-icons/material/Height");
var FileFont_1 = require("@styled-icons/bootstrap/FileFont");
var Dev_1 = require("@styled-icons/fa-brands/Dev");
var VideoModal_1 = __importDefault(require("./VideoModal"));
var ImageModal_1 = __importStar(require("./ImageModal"));
var HtmlModal_1 = __importStar(require("./HtmlModal"));
var CustomButton_1 = require("./CustomButton");
var HyperLinkButton_1 = __importStar(require("./HyperLinkButton"));
var RichTextPreview_1 = require("../RichTextPreview");
var IconWrapper = function IconWrapper(props) {
  return react_1.default.createElement("div", __assign({
    style: {
      margin: 3,
      width: 30,
      height: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: props.active ? 'bold' : 'normal',
      backgroundColor: props.active ? '#eee' : 'white',
      cursor: 'pointer'
    }
  }, props), props.children);
};
var Toolbar = function Toolbar(props) {
  return react_1.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      flexWrap: 'wrap',
      marginBottom: 10,
      borderBottom: 'solid 1px #eee',
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: '#fff'
    }
  }, props.children);
};
var LIST_TYPES = ['ol', 'ul'];
var initialValue = [{
  type: 'p',
  children: [{
    text: ''
  }]
}];
var Provider = function Provider(props) {
  var children = props.children,
    _onChange = props.onChange,
    content = props.content;
  var editor = react_1.default.useMemo(function () {
    return HyperLinkButton_1.withLinks(ImageModal_1.withImages(HtmlModal_1.withHtml(slate_history_1.withHistory(slate_react_1.withReact(slate_1.createEditor())))));
  },
  //withLinks(),
  []);
  react_1.useEffect(function () {
    slate_1.Transforms.deselect(editor);
  }, [editor]);
  react_1.useEffect(function () {
    try {
      if (!content || !Array.isArray(content)) {
        _onChange(initialValue);
      }
    } catch (err) {
      console.warn('RICH TEXT EDITOR initail parse error', content);
    }
  }, [content, _onChange]);
  function isEmpty(content) {
    if (content && content.length === 1) {
      if (content[0].children.length === 1) {
        if (content[0].children[0].text === '') {
          return true;
        }
      }
    }
    return false;
  }
  if (!content || !editor) {
    return react_1.default.createElement("div", null, "\u521D\u59CB\u5316...");
  }
  return react_1.default.createElement(slate_react_1.Slate, {
    editor: editor,
    value: content,
    onChange: function onChange(value) {
      // to fix typing chinese error
      if (isEmpty(value) && !isEmpty(content)) {
        slate_react_1.ReactEditor.blur(editor);
      }
      _onChange(value);
      // value or editor.children
    }
  }, children);
};
exports.Provider = Provider;
var RichTextEditor = function RichTextEditor(props) {
  var _a = props.token,
    token = _a === void 0 ? '' : _a;
  var editor = slate_react_1.useSlate();
  var _b = react_1.useState(false),
    showVideoModal = _b[0],
    toggleVideoModal = _b[1];
  var _c = react_1.useState(false),
    showImageModal = _c[0],
    toggleImageModal = _c[1];
  var _d = react_1.useState(false),
    showHtmlModal = _d[0],
    toggleHtmlModal = _d[1];
  var renderElement = react_1.useCallback(function (props) {
    return react_1.default.createElement(RichTextPreview_1.Element, __assign({}, props));
  }, []);
  var renderLeaf = react_1.useCallback(function (props) {
    return react_1.default.createElement(RichTextPreview_1.Leaf, __assign({}, props));
  }, []);
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Toolbar, null, react_1.default.createElement(MarkButton, {
    title: "\u7C97\u9AD4",
    format: "fontWeight",
    value: "bolder",
    icon: react_1.default.createElement(FormatBold_1.FormatBold, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(MarkButton, {
    title: "\u659C\u9AD4",
    format: "fontStyle",
    value: "italic",
    icon: react_1.default.createElement(FormatItalic_1.FormatItalic, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(MarkButton, {
    title: "\u5E95\u7DDA",
    format: "textDecoration",
    value: "underline",
    icon: react_1.default.createElement(FormatUnderlined_1.FormatUnderlined, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(MarkButton, {
    title: "\u522A\u9664\u7DDA",
    format: "textDecoration",
    value: "line-through",
    icon: react_1.default.createElement(FormatStrikethrough_1.FormatStrikethrough, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(MarkButton, {
    title: "\u87A2\u5149\u7B46",
    format: "backgroundColor",
    value: "yellow",
    icon: react_1.default.createElement(Highlighter_1.Highlighter, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(CustomButton_1.BlockPropButton, {
    title: "\u6C34\u5E73\u7F6E\u5DE6",
    format: "textAlign",
    value: "left",
    icon: react_1.default.createElement(FormatAlignLeft_1.FormatAlignLeft, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(CustomButton_1.BlockPropButton, {
    title: "\u6C34\u5E73\u7F6E\u4E2D",
    format: "textAlign",
    value: "center",
    icon: react_1.default.createElement(FormatAlignCenter_1.FormatAlignCenter, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(CustomButton_1.BlockPropButton, {
    title: "\u6C34\u5E73\u7F6E\u53F3",
    format: "textAlign",
    value: "right",
    icon: react_1.default.createElement(FormatAlignRight_1.FormatAlignRight, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(HyperLinkButton_1.default, null), react_1.default.createElement(BlockButton, {
    title: "\u6A19\u984C\u4E00",
    format: "h1",
    icon: react_1.default.createElement("span", {
      style: {
        fontSize: 16
      }
    }, "H")
  }), react_1.default.createElement(BlockButton, {
    title: "\u6A19\u984C\u4E8C",
    format: "h2",
    icon: react_1.default.createElement("span", {
      style: {
        fontSize: 12
      }
    }, "H")
  }), react_1.default.createElement(BlockButton, {
    title: "\u5340\u584A\u5F15\u8A00",
    format: "blockquote",
    icon: react_1.default.createElement(FormatQuote_1.FormatQuote, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(MarkButton, {
    format: "code",
    icon: react_1.default.createElement(Code_1.Code, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(BlockButton, {
    title: "\u6709\u5E8F\u5217\u8868",
    format: "ol",
    icon: react_1.default.createElement(FormatListNumbered_1.FormatListNumbered, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(BlockButton, {
    title: "\u7121\u5E8F\u5217\u8868",
    format: "ul",
    icon: react_1.default.createElement(FormatListBulleted_1.FormatListBulleted, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(CustomButton_1.FontColorButton, null), react_1.default.createElement(IconWrapper, {
    title: "\u63D2\u5165\u5716\u7247",
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggleImageModal(true);
    }
  }, react_1.default.createElement(Image_1.Image, {
    size: 16,
    color: "black"
  })), react_1.default.createElement(IconWrapper, {
    title: "\u63D2\u5165youtube",
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggleVideoModal(true);
    }
  }, react_1.default.createElement(VideoSettings_1.VideoSettings, {
    size: 16,
    color: "black"
  })), react_1.default.createElement(IconWrapper, {
    title: "\u63D2\u5165html",
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggleHtmlModal(true);
    }
  }, react_1.default.createElement(CodeCurly_1.CodeCurly, {
    size: 16,
    color: "black"
  })), react_1.default.createElement(SelectCustomValueButton, {
    title: "\u8ABF\u6574\u5B57\u9AD4\u5927\u5C0F",
    format: "fontSize",
    dataType: "number",
    values: [8, 10, 12, 16, 18, 20, 22, 24, 26, 28, 30, 32],
    icon: react_1.default.createElement(FormatSize_1.FormatSize, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(SelectCustomValueButton, {
    title: "\u8ABF\u6574\u884C\u8DDD",
    format: "lineHeight",
    dataType: "float",
    values: [0.8, 0.9, 1.0, 1.2, 1.5, 1.8, 2.0],
    icon: react_1.default.createElement(Height_1.Height, {
      size: 16,
      color: "black"
    })
  }), (props === null || props === void 0 ? void 0 : props.options) && props.options.fontFamilies && props.options.fontFamilies.length > 0 && react_1.default.createElement(SelectCustomValueButton, {
    title: "\u8ABF\u6574\u5B57\u578B",
    format: "fontFamily",
    dataType: "string",
    values: props.options.fontFamilies,
    icon: react_1.default.createElement(FileFont_1.FileFont, {
      size: 16,
      color: "black"
    })
  }), react_1.default.createElement(CustomButton_1.DbgButton, {
    icon: react_1.default.createElement(Dev_1.Dev, {
      size: 18,
      color: "black"
    })
  })), react_1.default.createElement("div", {
    style: {
      overflow: 'auto',
      flex: 1
    }
  }, react_1.default.createElement(slate_react_1.Editable
  /*
  onBlur={() => {
    editor._onBlurSelection = editor.selection;
  }}
  onFocus={() => {
    editor._onBlurSelection = null;
  }}
  */, {
    /*
    onBlur={() => {
      editor._onBlurSelection = editor.selection;
    }}
    onFocus={() => {
      editor._onBlurSelection = null;
    }}
    */
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    placeholder: "Enter some rich text\u2026",
    spellCheck: true,
    autoFocus: true
  })), react_1.default.createElement(VideoModal_1.default, {
    visible: showVideoModal,
    onCancel: function onCancel() {
      return toggleVideoModal(false);
    }
  }), react_1.default.createElement(ImageModal_1.default, {
    visible: showImageModal,
    onCancel: function onCancel() {
      return toggleImageModal(false);
    },
    onInsert: function onInsert(url, options) {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          ImageModal_1.insertImage(editor, url, options);
          return [2 /*return*/];
        });
      });
    },

    inContent: true,
    token: token
  }), react_1.default.createElement(HtmlModal_1.default, {
    visible: showHtmlModal,
    onCancel: function onCancel() {
      return toggleHtmlModal(false);
    },
    onInsert: function onInsert(value) {
      return HtmlModal_1.insertHtml(editor, value);
    }
  }));
};
var toggleBlock = function toggleBlock(editor, format) {
  var isActive = isBlockActive(editor, format);
  var isList = LIST_TYPES.includes(format);
  slate_1.Transforms.unwrapNodes(editor, {
    match: function match(n) {
      return LIST_TYPES.includes(n.type);
    },
    split: true
  });
  var nodeField = {
    type: isActive ? 'p' : isList ? 'li' : format
  };
  // @ts-ignore
  slate_1.Transforms.setNodes(editor, nodeField);
  if (!isActive && isList) {
    var block = {
      type: format,
      children: []
    };
    slate_1.Transforms.wrapNodes(editor, block);
  }
};
var toggleMark = function toggleMark(editor, format, value) {
  if (value === void 0) {
    value = true;
  }
  var isActive = isMarkActive(editor, format, value);
  if (isActive) {
    slate_1.Editor.removeMark(editor, format);
  } else {
    slate_1.Editor.addMark(editor, format, value);
  }
};
var isBlockActive = function isBlockActive(editor, format) {
  var it = slate_1.Editor.nodes(editor, {
    match: function match(n) {
      return n.type === format;
    }
  });
  return !!it.next().value;
};
var isMarkActive = function isMarkActive(editor, format, value) {
  if (value === void 0) {
    value = true;
  }
  var marks = slate_1.Editor.marks(editor);
  return marks ? marks[format] === value : false;
};
var BlockButton = function BlockButton(_a) {
  var title = _a.title,
    format = _a.format,
    icon = _a.icon;
  var editor = slate_react_1.useSlate();
  return react_1.default.createElement(IconWrapper, {
    title: title,
    active: isBlockActive(editor, format),
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggleBlock(editor, format);
    }
  }, icon);
};
var MarkButton = function MarkButton(_a) {
  var title = _a.title,
    format = _a.format,
    icon = _a.icon,
    _b = _a.value,
    value = _b === void 0 ? true : _b;
  var editor = slate_react_1.useSlate();
  return react_1.default.createElement(IconWrapper, {
    title: title,
    active: isMarkActive(editor, format, value),
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      toggleMark(editor, format, value);
    }
  }, icon);
};
var SelectCustomValueButton = function SelectCustomValueButton(_a) {
  var title = _a.title,
    format = _a.format,
    dataType = _a.dataType,
    values = _a.values,
    icon = _a.icon;
  var editor = slate_react_1.useSlate();
  var marks = slate_1.Editor.marks(editor) || {};
  var value = marks[format] || '';
  var active = !!value;
  return react_1.default.createElement("div", {
    title: title,
    style: {
      position: 'relative',
      width: 30,
      height: 30,
      margin: 3,
      overflow: 'hidden',
      backgroundColor: active ? '#eee' : '#fff',
      fontWeight: active ? 'bold' : 'normal',
      cursor: 'pointer'
    }
  }, react_1.default.createElement("div", {
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  }, icon), react_1.default.createElement("select", {
    value: value,
    onChange: function onChange(e) {
      var nextValue = e.target.value || '';
      if (dataType === 'number') {
        nextValue = parseInt(nextValue);
      } else if (dataType === 'float') {
        nextValue = parseFloat(nextValue);
      } else if (dataType === 'string') {
        nextValue = nextValue.toString();
      }
      toggleMark(editor, format, nextValue);
    },
    style: {
      opacity: 0
    }
  }, react_1.default.createElement("option", null, title), values.map(function (value) {
    return react_1.default.createElement("option", {
      value: value
    }, value);
  })));
};
function default_1(props) {
  return react_1.default.createElement(exports.Provider, {
    content: props.content,
    onChange: props.onChange
  }, react_1.default.createElement(RichTextEditor, {
    token: props.token,
    options: props.options
  }));
}
exports.default = default_1;